import './index.css';

export default {
  name: 'Abox',
  props: {
    flex: { type: Boolean, default: () => false },
  },
  render() {
    const { margin, padding, ...attrs } = this.$attrs;
    return (
      <div class={['a-box', (this.flex ? 'flex' : null)]} style={{ margin, padding }} {...{ attrs }}>
        {this.$slots.default}
      </div>
    );
  }
}